module.exports = __webpack_public_path__ + "media/images/element/marketing-d4c375d8fdfc3643f9a431621f93a1ae.svg";